import { createSlice, PayloadAction } from "@reduxjs/toolkit";
type BrokerState = {
  broker_name: string;
  logo: string;
  favicon_icon: string;
};
const initialState = {
  broker_name: "",
  logo: "",
  favicon_icon: "",
};

const brokerSlice = createSlice({
  name: "broker",
  initialState,
  reducers: {
    // 🔹 set full data
    setBrokerData: (state, action) => {
      state.broker_name = action?.payload?.broker_name || "";
      state.logo = action?.payload?.logo || "";
      state.favicon_icon = action?.payload?.favicon_icon || "";
    },

    // 🔹 update single field
    updateBrokerField: (
      state,
      action: PayloadAction<{
        key: keyof BrokerState;
        value: string;
      }>,
    ) => {
      const { key, value } = action.payload;
      state[key] = value;
    },

    resetBroker: () => initialState,
  },
});

export const { setBrokerData, updateBrokerField, resetBroker } =
  brokerSlice.actions;

export default brokerSlice.reducer;
